/** @format */
import angular from 'angular';
import { locationModelModule } from '../model/location.model';
import { jsDataCacheHelperModule } from './jsDataCacheHelper.service';

export const locationServiceModule = 'sis-components.service.locationService';

angular.module(locationServiceModule, [jsDataCacheHelperModule, locationModelModule]).factory('locationService', [
    'jsDataCacheHelper',
    'locationJSDataModel',
    '$http',
    (jsDataCacheHelper, locationJSDataModel, $http) => ({
        findByIds(ids) {
            return jsDataCacheHelper.findByIds(locationJSDataModel, ids);
        },
        searchByString(fullTextQuery, universityOrgId) {
            return $http({
                url: '/kori/api/locations/search',
                method: 'GET',
                params: {
                    fullTextQuery,
                    universityOrgId,
                },
            }).then(result => result.data);
        },
    }),
]);
